@if (isBrowser && mapCenter.latitude && mapCenter.longitude) {
  @if (cookieAccepted$() | async) {
    <google-map
      #googleMap
      [options]="{ gestureHandling: 'greedy' }"
      (mapInitialized)="mapLoaded($event)"
      [center]="{ lat: mapCenter.latitude, lng: mapCenter.longitude }"
      [height]="'100%'"
      [width]="'100%'"
    >
      @if (
        sourceMarkerPosition &&
        sourceMarkerPosition.latitude &&
        sourceMarkerPosition.longitude
      ) {
        <map-marker
          [options]="{
            icon: sourceMarker.iconUrl,
            position: {
              lat: sourceMarkerPosition.latitude,
              lng: sourceMarkerPosition.longitude,
            },
          }"
        >
        </map-marker>
      }
      @for (
        pointOfService of pointOfServices;
        track pointOfService;
        let i = $index
      ) {
        @if (pointOfService.geoPoint) {
          @if (pointOfService.label) {
            <map-marker
              (mapClick)="clickMarker(pointOfService)"
              [options]="{
                label: pointOfService.label,
                icon:
                  pointOfService.name === active.name
                    ? greyMarker.iconUrl
                    : pointOfService.isCramoPOS
                      ? redMarker.iconUrl
                      : orangeMarker.iconUrl,
                zIndex:
                  pointOfService.name === active.name ? 1000 : 1000 - (i + 1),
                position: {
                  lat: pointOfService.geoPoint.latitude,
                  lng: pointOfService.geoPoint.longitude,
                },
              }"
            ></map-marker>
          }
        }
      }
    </google-map>
  } @else {
    <div class="map-cookie"></div>
  }
}
